<template>
    <section v-if="data?.Series" class="flex flex-col text-base gap-4">
        <ManufacturerSeriesHeader />
        <ManufacturerSeriesCategories />
        <h2 class="container-left my-0">{{ $t("Global.Parts") }}</h2>
        <CategoryFilters />
        <CategoryParts :series="data?.Series" />
    </section>
</template>
<script setup lang="ts">
const route = useRoute();
const router = useRouter();
const { t } = useI18n();
const manufacturer = useStateManufacturer();
const { company, basePartNumber } = route.params;
const { $api } = useNuxtApp();

const category = ref<Category | null>(null);
const filterOptions = ref<FilterOption[]>([]);
const filterValues = ref<FilterValues>({ inStock: false, manufacturers: [], specs: [] });

type ProductSeriesResponse = {
    Series: ProductSeries;
    Manufacturer: ManufacturerDetails;
    Category: Category;
};

const { data } = await useApi<ProductSeriesResponse>("product-series/one", {
    query: { virtualPath: company, basePartNumber },
});

if (data.value) {
    category.value = data.value.Category;
    manufacturer.value = data.value.Manufacturer;
    const mfrPath = data.value.Manufacturer.VirtualPath;
    await router.replace({ params: { company: mfrPath } });

    filterOptions.value = await $api<FilterOption[]>("product-series/filters", {
        query: { productSeriesId: data.value.Series.Id, categoryId: data.value.Category.Id },
    });

    filterValues.value = getCategoryFilterValues(filterOptions.value, route.query);
}

const title = computed(() => t("ProductSeries.TitleFormat", [manufacturer.value?.Name, basePartNumber]));
const description = computed(() =>
    t("ProductSeries.MetaDescriptionFormat", [manufacturer.value?.Name, basePartNumber])
);

useSeoMeta({ title, ogTitle: title, description, ogDescription: description });

provide(CategoryInjectKey, { category, filterOptions, filterValues });
</script>
